import React from "react";
import { StaticAnalysisEntry } from "../../../@types/rldynamicanalysis/staticanalysis";
import styles from "./rlcscloudsandboxapk.module.scss";

interface Props {
  certificates?: StaticAnalysisEntry["certificate"];
}

const rows: {
  key: keyof NonNullable<StaticAnalysisEntry["certificate"]>[number];
  label: string;
}[] = [
  { key: "issuer", label: "Issuer" },
  { key: "subject", label: "Subject" },
  { key: "md5", label: "MD5" },
  { key: "sha1", label: "SHA-1" },
  { key: "sha256", label: "SHA-256" }
];

const CertificateTable: React.FC<Props> = ({ certificates }) => {
  if (!certificates) return null;

  return (
    <div className={styles.certificate_tables}>
      {certificates.map((cert, idx) => (
        <>
          <table key={cert.sha256 || idx} className={"simple-table"}>
            <tbody>
              {rows.map(row => {
                const key = row.key;
                const value = cert[key];
                if (!value) return null;
                return (
                  <tr key={`${key}-${value}`}>
                    <th colSpan={1}>{row.label}</th>
                    <td colSpan={4}>{String(value)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {idx < certificates.length - 1 && (
            <div className={styles.table_divider} />
          )}
        </>
      ))}
    </div>
  );
};

export default CertificateTable;
